/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reports/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconAssessment from 'DesignSystem/Svgs/TysiaIconAssessment/index'



/** @type {import('Simple/types.js').View} */
export default function Reports({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab/Icon/Reports",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
  return (<React.Fragment
>
<TysiaIconAssessment
  viewPath={`${viewPath}/TysiaIconAssessment`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsGreen600 : hovered ? dtColorsWhite : selected ? dtColorsGreen600 : dtColorsWhite}
/>
{children}
</React.Fragment>)
}